  <div class="tw-flex tw-flex-col tw-h-full tw-overflow-y-auto" id="checkoutPage"
    [class.tw-pt-24]="!orderFlowHeader"
    [class.tw-bg-gray-100]="orderFlowHeader">
    @if (orderFlowHeaderResolved) {
      @if (orderFlowHeader) {
        <header class="tw-sticky tw-top-0 tw-z-40"
          [class.tw-bg-white]="!fromLocationAutofill"
          [class.tw-bg-gray-800]="fromLocationAutofill">
          <div class="tw-relative tw-flex tw-items-center tw-justify-center tw-px-6"
            [class.tw-py-3]="!fromLocationAutofill"
            [class.tw-h-18]="fromLocationAutofill">
            <div class="tw-absolute tw-left-6 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center"
              [class.tw-text-gray-800]="!fromLocationAutofill"
              [class.tw-text-white]="fromLocationAutofill"
              (click)="back()">
              <cs-icon class="tw-h-full tw-w-full"
              [iconName]="'arrow_left'"></cs-icon>
            </div>
            <h1
              class="tw-text-center tw-text-300 tw-font-lexend"
              [class.tw-font-bold]="!fromLocationAutofill"
              [class.tw-text-gray-800]="!fromLocationAutofill"
              [class.tw-font-normal]="fromLocationAutofill"
              [class.tw-text-white]="fromLocationAutofill"
              i18n="@@confirmAddress"
            >Confirm Address</h1>
          </div>
          @if (showOrderFlowSteps) {
            <app-order-flow-steps [activeStep]="OrderFlowStep.ADDRESS"></app-order-flow-steps>
          }
        </header>
      } @else {
        <div id="back" class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
        </div>
      }
    }
    @if (ui.loading || !(defaultAddress$ | async)) {
      <loading class="tw-flex-1 tw-justify-self-center tw-self-center"></loading>
    }
    @if (defaultAddress$ | async; as defaultAddress) {
      @if (orderFlowHeader) {
        @if (!ui.loading) {
          <div id="address"
            (click)='navigateTo("/user/addresses")'
            class="tw-relative tw-mx-6 tw-mt-6 tw-flex tw-flex-col tw-gap-4 tw-rounded-2 tw-bg-white tw-p-4 tw-shadow-z4">
            <cs-icon class="tw-absolute tw-right-4 tw-top-4 tw-h-4 tw-w-4 tw-text-teal-600" [iconName]="'check_rounded'"></cs-icon>
            <div class="tw-flex tw-flex-col">
              <p class="tw-font-lexend tw-text-100 tw-uppercase tw-text-gray-500" i18n="@@name">Name</p>
              <p id="contact-name" class="tw-break-words tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800">{{defaultAddress?.contactName}}</p>
            </div>
            <div class="tw-flex tw-flex-col">
              <p class="tw-font-lexend tw-text-100 tw-uppercase tw-text-gray-500" i18n="@@phoneNumber">Phone Number</p>
              @if (!internalUser) {
                <p id="mobile-number" class="tw-break-words tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800">{{defaultAddress?.mobileNumber || user?.get('MobileNumber')}}</p>
              }
            </div>
            <div class="tw-flex tw-flex-col">
              <p class="tw-font-lexend tw-text-100 tw-uppercase tw-text-gray-500" i18n="@@address"> Address </p>
              <p id="delivery-address" class="tw-break-words tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800">{{getDeliveryAddress(defaultAddress)}}</p>
            </div>
            <div class="tw-flex tw-w-fit tw-items-center tw-gap-1 tw-text-teal-600">
              <span class="tw-font-lexend tw-text-300 tw-font-semibold" i18n="@@changeAddAddress"> Change or Add address </span>
              <cs-icon class="tw-shrink-0 tw-h-4 tw-w-4" [iconName]="'chevron_right_teal_rounded'"></cs-icon>
            </div>
          </div>
        }
      } @else {
      <div class="ld-session-block tw-mx-6">
        @if (!ui.loading) {
          <div id="address"
            (click)='navigateTo("/user/addresses")'
            class="tw-flex tw-flex-col tw-border tw-gap-4 tw-p-4 tw-border-teal-700 tw-rounded-lg">
            <div class="tw-flex tw-flex-col tw-relative">
              <div class="tw-font-lexend tw-text-100 tw-leading-[21px] tw-text-gray-500  tw-uppercase tw-tracking-[1px] tw-break-words" i18n="@@name">Name</div>
              <cs-icon class="tw-shrink-0 tw-w-4 tw-h-4 tw-text-teal-600 tw-absolute tw-top-0 tw-right-0" [iconName]="'done'"></cs-icon>
              <div id="contact-name" class="tw-break-words value tw-font-lexend tw-font-medium tw-text-400 tw-text-gray-800">
                {{defaultAddress?.contactName}}
              </div>
            </div>
            <div class="tw-flex tw-flex-col">
              <div class="tw-text-100 tw-uppercase tw-break-words tw-font-lexend tw-leading-[21px] tw-text-gray-500" i18n="@@phoneNumber">Phone Number</div>
              @if (!internalUser) {
                <div id="mobile-number" class="tw-break-words tw-font-lexend tw-font-medium tw-text-400 tw-text-gray-800">
                  {{defaultAddress?.mobileNumber || user?.get('MobileNumber')}}
                </div>
              }
            </div>
            <div class="tw-flex tw-flex-col">
              <div class="tw-text-100 tw-uppercase tw-break-words tw-font-lexend tw-leading-[21px] tw-text-gray-500" i18n="@@address"> Address </div>
              <div id="delivery-address" class="tw-break-words tw-font-lexend tw-font-medium tw-text-400 tw-text-gray-800">
                {{getDeliveryAddress(defaultAddress)}}
              </div>
            </div>
            <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-fit tw-py-[5px] tw-pl-4 tw-pr-2 tw-border tw-border-teal-600 tw-rounded-lg">
              <div class="change-add-address tw-tracking-normal tw-font-lexend tw-font-semibold tw-text-300 tw-leading-[21px] tw-text-teal-600" i18n="@@changeAddAddress"> Change or Add address </div>
              <cs-icon class="tw-shrink-0 tw-w-4 tw-h-4 tw-text-teal-600" [iconName]='"chevron_right_teal_rounded"'></cs-icon>
            </div>
          </div>
        }
      </div>
      }
    }
    @if (defaultAddress$ | async) {
      @if (showLegacyDeliveryInfo) {
      <div class="tw-flex tw-flex-row tw-items-center tw-px-4 tw-bg-gray-100 tw-rounded-xl tw-mx-6 tw-gap-4 tw-py-2 tw-mt-5">
        <div class="tw-block tw-bg-transparent tw-w-[84px] tw-h-[90px] tw-shrink-0" src="" alt="">
          <img class="tw-w-full tw-h-full tw-object-contain" src="https://cdn.cureskin.com/app/img/order.gif" alt="order"/>
        </div>
        @if (isEnglishOrHindiUser) {
          <div id="dynamic-expected-delivery-date" class="tw-flex-1">
            @if (orderDeliveryDateToCurrentDateDifference <= 3) {
              <span class="tw-text-300 tw-font-lexend tw-text-gray-500" i18n="@@youWillReceiveOn">
              Your order is expected to be delivered on
            </span>
            } @else {
              <span class="tw-text-300 tw-font-lexend tw-text-gray-500" i18n="@@youWillReceiveOn">
              Your order is expected to be delivered on
            </span>
            }
            @if ((!expectedDeliveryDate.to && !expectedDeliveryDate.from)) {
              <div class="tw-flex tw-justify-center tw-items-center tw-pr-3">
                <loading class="tw-scale-75"></loading>
              </div>
            }
            <ng-container>
              @if(orderDeliveryDateToCurrentDateDifference >=0  && orderDeliveryDateToCurrentDateDifference <= 1) {
                <p id="expected-delivery-date-1" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle" i18n="@@byTomorrow">
                by tomorrow
              </p>
              } @else if (orderDeliveryDateToCurrentDateDifference === 2) {
                <p id="expected-delivery-date-2" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle" i18n="@@within2Days">
                within 2 days
              </p>
              } @else if(orderDeliveryDateToCurrentDateDifference === 3) {
                <p id="expected-delivery-date-3" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle" i18n="@@within3Days">
                within 3 days
              </p>
              } @else {
                <p id="expected-delivery-date" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle">
                  {{expectedDeliveryDate.from | date: 'd MMM' }} - {{expectedDeliveryDate.to | date: 'd MMM'}}
                </p>
              }
            </ng-container>
          </div>
        } @else {
          <div id="static-expected-delivery-date" class="tw-flex-1">
            <p class="tw-text-300 tw-font-lexend tw-text-gray-500" i18n="@@youWillReceiveOn"> Your order is expected to be delivered on </p>
            @if (!expectedDeliveryDate.to && !expectedDeliveryDate.from) {
              <div class="tw-flex tw-justify-center tw-items-center tw-pr-3">
                <loading class="tw-scale-75"></loading>
              </div>
            }
            @if (expectedDeliveryDate.to && expectedDeliveryDate.from) {
              <p id="expected-delivery-date-custom" class="tw-font-bold tw-text-600 tw-text-black tw-font-lexend tw-mt-2 tw-align-middle">
                {{expectedDeliveryDate.from | date: 'd MMM' }} - {{expectedDeliveryDate.to | date: 'd MMM'}}
              </p>
            }
          </div>
        }
      </div>
      }
    }
    <div class="tw-flex-1"></div>
    @if (showOrderFlowDeliveryBar) {
      <app-delivery-estimate-strip class="tw-block tw-overflow-hidden tw-rounded-b-2"
        [dayDifference]="orderDeliveryDateToCurrentDateDifference"
        [expectedDeliveryDate]="expectedDeliveryDate"></app-delivery-estimate-strip>
    }
    @if (!ui.loading && defaultAddress$ | async) {
      <div class="flex-footer" [class.tw-bg-gray-75]="orderFlowHeader">
        @if (offerTimer.endTime > 0 && typeOfOrder === appConfig.Shared.Order.Type.REGIMEN) {
          <div class="tw-w-full">
            <discount-timer id="discount-timer" [endTime]="offerTimer.endTime" [text]="offerTimer.title"></discount-timer>
          </div>
        }
        <div class="tw-w-full tw-p-5">
          <button csButton
            id="selectPaymentRebranded"
            type="button"
            class="tw-w-full"
            [loading]="(checkoutInProgress$ | async)"
            (click)="checkout()"
            i18n="@@proceedToPay"
          >Proceed to pay</button>
        </div>
      </div>
    }
  </div>
